import { useEffect, useState } from "react";
import { accessDeadline, accessPaused } from "../lib/access";

export default function useAccessDeadline(family) {
  const [now, setNow] = useState(Date.now);
  const deadline = accessDeadline(family);
  useEffect(() => {
    let timer;
    const update = () => {
      const current = Date.now();
      setNow(current);
      clearTimeout(timer);
      if (deadline !== null && deadline > current) {
        timer = setTimeout(update, Math.min(deadline - current, 86400000));
      }
    };
    update();
    window.addEventListener("focus", update);
    document.addEventListener("visibilitychange", update);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("focus", update);
      document.removeEventListener("visibilitychange", update);
    };
  }, [deadline]);
  return accessPaused(family, Math.max(now, Date.now()));
}
